import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const WYSIWYGEditor = ({ field, form, ...props }: any) => {
  const handleChange = (value: any) => {
    form.setFieldValue(field.name, value);
  };

  const modules = {
    toolbar: [
      [{ header: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['link'],
      [{ color: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false
    }
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'link',
    'color',
    'list',
    'bullet',
    'clear'
  ];

  return (
    <div>
      <ReactQuill
        value={field.value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        {...props}
      />
      {form.touched[field.name] && form.errors[field.name] && (
        <div>{form.errors[field.name]}</div>
      )}
    </div>
  );
};

export default WYSIWYGEditor;
